<template>
  <div class="container">
    <div class="navi">
        <span class="icon-arrow-left" @click="goto('/pest-step1')"></span>
    </div>
    <div class="title">退房除虫套餐</div>
    <br>
    <div class="main">


      <div class="pest-option">
        <div class="btn-long no-margin-top" @click="order.data.pest_standard = true;order.data.pest_german = true;order.data.pest_mouse = false;orderUpdateAll('/pest-step4');">
          <div class="col1">
            <div class="col1-row1">除虫套餐 A</div>
          <div class="col1-row2">一般害虫 + 小蟑螂</div>
          </div>
          <div class="col2">
<!--             <div class="col2-row1"><span class="col-price">$99<span class="small">起</span></span></div>
            <div class="col2-row2">原价: $355</div>
            <div class="col2-row3">特惠全包价</div> -->
          </div>
          <div class="col-3">
            <span class="icon-chevron-right"></span></span>
          </div>
        </div>

      <div class="btn-long" @click="order.data.pest_standard = true;order.data.pest_german = true;order.data.pest_mouse = true;orderUpdateAll('/pest-step4');">
        <div class="col1">
          <div class="col1-row1">除虫套餐 B</div>
          <div class="col1-row2">一般害虫 + 小蟑螂 + <span class="color-orange">除鼠</span></div>
        </div>
        <div class="col2">
<!--           <div class="col2-row1"> <span class="col-price">$110<span class="small">起</span></span></div>
          <div class="col2-row2">原价: $355</div>
          <div class="col2-row3">特惠全包价</div> -->
        </div>
        <div class="col-3">
          <span class="icon-chevron-right"></span></span>
        </div>
      </div>
      </div>

      <div class="bargainRecord">
          <div class="bargainRecord_title">
                  虫害介绍
          </div>
      </div>

      <div class="introbox">
        <div class="btn-long no-margin-top">
          <div class="col1">
            <img class="promo-image" src='../../assets/img/pest/chuchong.svg'>
          </div>
          <div class="col2">
            <div class="col2-row1">一般害虫</div>
            <div class="col2-row2">大蟑螂、蚂蚁、蜘蛛、银鱼、蟋蟀、马蜂等</div>
          </div>
        </div>

        <div class="btn-long">
          <div class="col1">
            <img class="promo-image" src='../../assets/img/pest/xiaolian.svg'>
          </div>
          <div class="col2">
            <div class="col2-row1">小蟑螂（德国小蠊）</div>
            <div class="col2-row2">厨房和卫生间中常见的小蟑螂</div>
          </div>
        </div>

        <div class="btn-long">
          <div class="col1">
            <img class="promo-image" src='../../assets/img/pest/laoshu.svg'>
          </div>
          <div class="col2">
            <div class="col2-row1">老鼠</div>
            <div class="col2-row2">专业除鼠服务，包含除鼠盒安装和二次检查</div>
          </div>
        </div>
      </div>

    </div>
    <img :src="pixelURL('cangchu','step2')" class="hide">
  </div>
</template>

<script>
export default {
  name: 'step3',
  data () {
    return {
      order:{},
      localError:[],
      localErrorShow:false,
    }
  },
  methods: {
    allFilled(){
       if(this.order.data.pest_standard || this.order.data.pest_german || this.order.data.pest_mouse ){
            return true;
        }
    },
    checkSubmit(){
        this.localError = [];
        if (!this.allFilled()) {
            this.localError.push("请至少选择一项除虫服务");
        }
        if (!this.localError.length) {
          return true;
        }
        else{
          this.localErrorShow = true;
          return false;
        }
    },
    nextStep: function() {
        if(!this.checkSubmit()){
            return false;
        }
        else{
            if(this.order.data.pest_standard){
              
            }
            this.orderUpdateAll('/pest-step4');
        }
    },
  },
  created: function () {
    //如果LS存在老的下单信息
    if (localStorage.savedPest){
      //如果LS不存在order字段，则将老下单信息覆盖LS的order字段
      if(!localStorage.order){
        localStorage.order = localStorage.savedPest;
      }//如果LS存在order字段，判断其是否属于当前服务类型：如果否，则将老下单信息覆盖LS的order字段
      if(localStorage.order){
        let localParsed = JSON.parse(localStorage.order);
        if(localParsed.service != "pest"){
          localStorage.order = localStorage.savedPest;
        }
      }
    }
    if (localStorage.order) {
      let localParsed = JSON.parse(localStorage.order);
      if(localParsed.service == "pest"){
        this.order = localParsed;
      }
    }
    document.querySelector("html").classList.add("grey-background");
  },
  destroyed() {
    document.querySelector("html").classList.remove("grey-background");
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../assets/css/base.scss";

.container /deep/ .weui-cell:before{
  display:none;
}

.container /deep/ .weui-cells:after, .container /deep/ .weui-cells:before{
  display:none;
}


.introbox{
  padding:6px 0px;
  margin:0 25px;
  border-radius:10px;
  .btn-long{
    width: 100%;
    min-height: 64px;
    cursor: pointer;
    display: flex;
    justify-content:space-around;
    align-items: center;
    border-radius: 5px;
    font-size: 1.1em;
    box-sizing:border-box;
    text-align:left;
    font-weight:bold;
    &.active{
      border:2px solid $color-orange;
    }
  }

  .btn-intro{
    font-size:0.7em;
    font-weight:normal;
  }


  .no-margin-top{
    margin-top:0;
  }

  .promo-image{
    width:70%;
    margin:4px auto;
    display:block;
    
  }

  .col1{
      -webkit-box-flex: 2;
      -webkit-flex: 2;
      flex: 2;
  }

  .col1-row1{
    color:#555;
    line-height:1;
    font-size:1.1em;
  }
  .col1-row2{
    border:1px solid #ff7444;
    border-radius:3px;
    font-size:0.7em;
    font-weight:200;
    color:#000;
    padding:0px 5px;
    display:inline-block;
  }

  .col2{
      -webkit-box-flex: 7;
      -webkit-flex: 7;
      flex: 7;
      padding-left:2vw;
  }


  .col2-row1{
    text-align:left;
    font-size:0.9em;
    color:#5A5D67;
  }

  .active .col2-row1{
    color:$color-orange;
  }

  .col2-row2{
    color:#999;
    font-size:0.65em;
    text-align:left;
    margin-top:2px;
    margin-bottom:2px;
  }

  .col2-row3{
    color:#999;
    font-size:0.7em;
    text-align:right;
    margin-top:2px;
    margin-bottom:2px;
    font-weight:200;
  }

  .col-3{
    font-size:2em;
    color:#ccc;
  }

}


.pest-option{
  .btn-long{
    width: 85%;
    height: 112px;
    cursor: pointer;
    display: flex;
    justify-content:space-around;
    align-items: center;
    border-radius: 10px;
    font-size: 1.1em;
    margin: 0 auto;
    margin-top: 20px;
    padding-left:6vw;
    box-sizing:border-box;
    text-align:left;
    font-weight:bold;
    background: #fff;
    border:1px solid #ddd;
    -webkit-box-shadow: 0 6px 10px -6px rgba(0,0,0,0.2);
    -moz-box-shadow: 0 6px 10px -6px rgba(0,0,0,0.2);
    box-shadow: 0 6px 10px -6px rgba(0,0,0,0.2);
  }

  .btn-intro{
    font-size:0.7em;
    font-weight:normal;
  }


  .no-margin-top{
    margin-top:0;
  }

  .promo-image{
    width:80%;
    margin:6px auto;
    display:block;
    
  }

  .col1{
      -webkit-box-flex: 3;
      -webkit-flex: 3;
      flex: 3;
  }

  .col1-row1{
    color:#555;
    line-height:1;
    font-size:1.1em;
  }
  .col1-row2{
    border-radius:3px;
    font-size:0.7em;
    color:#777;
    display:inline-block;
    padding:2px 8px;
    border:1px solid #ddd;
    margin-top:12px;

  }

  .col2-row1{
    text-align:right;
    font-size:0.8em;
    color:#666;
  }

  .col2-row2{
    text-decoration:line-through;
    color:#999;
    font-size:0.7em;
    text-align:right;
    margin-top:2px;
    margin-bottom:2px;
    font-weight:200;
  }

  .col2-row3{
    color:#666;
    font-size:0.7em;
    text-align:right;
    font-weight:200;
  }

  .col-3{
    font-size:2em;
    color:#ccc;
    padding:0 6px;
  }

  .col-price{
    color:#ff7444;
    font-size:1.6em;
  }
}


.bargainRecord{
  text-align:center;
  padding:40px 40px 4px 40px;
}
.bargainRecord_title{
    font-weight: bold;
    text-align: center;
    position: relative;
    color:#666;
    font-size:1.2em;
}
/*文字前*/
.bargainRecord_title:before {
    content: "";
    position: absolute;
     width: 30%;/*横线长度 */
    height: 1px;
    top: 50%;
    background: #ddd;
    left: 0;
  }
  /*文字后*/
.bargainRecord_title:after {
    content: "";
    position: absolute;
    width: 30%;
    height: 1px;
    top: 50%;
    background: #ddd;
    right: 0%;
}
.small{
  font-size:0.6em;
}
</style>



// WEBPACK FOOTER //
// src/pages/pest/step2-moveout.vue